(function () {
	'use strict';
	angular.module('app.core')
		.service('itemColumns', itemColumns);

	itemColumns.$inject = ['tableRenderService', '$experiments'];
	function itemColumns(tableRenderService, $experiments) {
		return [{
			id: 'actionStatus',
			display: 'Task Status',
			renderer: tableRenderService.statusWithCircle,
			sort: false,
			width: 80,
			conditional: hideFromSuppliers
		}, {	
			id: 'itemCode',
			display: 'Item Code',
			width: 200,
			sort: true,
			renderer: tableRenderService.itemCode,
			itemDrilldownSection: 'stockSection'
		},{
			id: 'itemDescription',
			display: 'Item Description',
			width: 120,
			sort: true
		},
		{
			id: 'itemAlias',
			display: 'Item Alias',
			width: 180,
			show: false
		}, {
			id: 'orderMultipleFloat',
			display: 'Lot Size',
			width: 100,
			sort: false,
			renderer: tableRenderService.lotSizeRenderer
		}, {
			id: 'itemType',
			display: 'Item Type',
			width: 100,
			sort: true
		}, {
			id: 'itemGroupName',
			display: 'Item Group',
			width: 100,
			sort: true
		}, {
			id: 'actionCategory',
			display: 'Task Category',
			show: false,
			width: 100,
			renderer: tableRenderService.actionCategoryRenderer,
			conditional: hideFromSuppliers
		}, {
			id: 'factoryName',
			display: 'Site',
			width: 120
		}, {
			id: 'supplierName',
			display: 'Supplier',
			width: 120
		}, {
			id: 'erpOrderPolicy',
			display: 'ERP Order Policy',
			width: 100,
			sort: true
		}, {
			id: 'orderPolicy',
			display: 'Order Policy',
			show: false,
			width: 80
		}, {
			id: 'isVmi',
			display: 'VMI item',
			show: false,
			width: 80,
			sort: true,
			renderer: tableRenderService.yesNo
		}, {
			id: 'supplierCode',
			display: 'Supplier Code',
			width: 80
		}, {
			id: 'abcClass',
			display: 'ABC Rank',
			show: false,
			width: 80
		}, {
			id: 'abcAnalysisType',
			display: 'Proposed ABC Rank',
			show: false,
			width: 80
		}, {
			id: 'orderIntervalInt',
			display: 'Order Interval',
			show: false,
			width: 80,
			renderer: tableRenderService.orderIntervalByOrderPolicyRenderer
		}, {
			id: 'analysisOrderIntervalInt',
			display: 'Recommended Order Interval',
			show: false,
			width: 80,
			renderer: tableRenderService.orderIntervalByOrderPolicyRenderer
		}, {
			id: 'minLevelFloat',
			display: 'Min Level',
			renderer: tableRenderService.integer,
			show: false,
			width: 80
		}, {
			id: 'calculatedMinLevel',
			display: 'Recommended Min Level',
			renderer: tableRenderService.integer,
			show: false,
			width: 80
		}, {
			id: 'buyerCode',
			display: 'Buyer',
			width: 100,
			sort: true,
			renderer: tableRenderService.buyerCode
		}, {
			id: 'planner',
			display: 'Planner',
			width: 100,
			sort: true
		}, {
			id: 'uom',
			display: 'UOM',
			width: 60,
			sort: true,
			aliases: 'itemUom'
		}, {
			id: 'standardPrice',
			display: 'Standard Price',
			class: 'alignRight',
			width: 100,
			sort: true,
			renderer: tableRenderService.currency,
			keepAllDecimals: true
		}, {
			id: 'leadTimeInDaysFloat',
			display: 'Lead Time',
			class: 'alignRight',
			renderer: tableRenderService.leadTime,
			width: 150,
			sort: true,
			headerTitle: 'The quoted lead time of the item taken from the ERP system (in days).'
		}, {
			id: 'materialGroup',
			display: 'Material Group',
			width: 140,
			sort: true
		}, {
			id: 'externalMaterialGroup',
			display: 'External Material Group',
			show: false,
			width: 80
		}, {
			id: 'materialType',
			display: 'Material Type',
			width: 80,
			sort: true
		}, {
			id: 'analysisAvgDailyDemandFloat',
			display: 'Company Defined Demand (Daily)',
			width: 150,
			renderer: tableRenderService.avgPeriodicDemand,
			inputPeriod: 'daily',
			class: 'alignRight',
			period: 'daily'
		}, {
			id: 'analysisAvgMonthlyDemandFloat',
			display: 'Company Defined Demand (Monthly)',
			width: 150,
			class: 'alignRight',
			renderer: tableRenderService.avgPeriodicDemand
		}, {
			id: 'analysisAverageDailyCostFloat',
			display: 'Average Daily Cost',
			width: 120,
			sort: true,
			renderer: tableRenderService.currency
		}, {
			id: 'analysisDailyDemandStdDevFloat',
			display: 'Weekly Demand Std. Deviation',
			show: false,
			width: 100,
			multiplier: 5,
			renderer: tableRenderService.decimal
		}, {
			id: 'analysisTotalDemand',
			display: 'Total Demand',
			show: false,
			width: 80,
			renderer: tableRenderService.decimal
		}, {
			id: 'daysCoverage',
			display: 'Days Coverage (Work Days)',
			class: 'buyerCell alignRight',
			width: 100,
			renderer: tableRenderService.decimal,
			show: false,
			sort: true,
			aggregate: false
		}, {
			id: 'potentialSavings',
			display: 'Potential Savings',
			renderer: tableRenderService.currency,
			sortDefaultReverse: true,
			width: 80
		}, {
			id: 'currentVsPotential',
			display: 'Current vs Potential',
			show: false,
			renderer: tableRenderService.currency,
			width: 100
		}, {
			id: 'mrpResizingOpportunity',
			display: 'MRP Resize Savings',
			show: false,
			renderer: tableRenderService.currency,
			width: 100
		}, {
			id: 'minMaxResizeSavings',
			display: 'MinMax Resize Savings',
			show: false,
			renderer: tableRenderService.currency,
			width: 100
		}, {
			id: 'reorderPointActionSavings',
			display: 'Reorder Point Resize Savings',
			show: false,
			renderer: tableRenderService.currency,
			width: 100
		}, {
			id: 'inventoryActionAssigned',
			display: 'Inventory Action Assigned',
			show: false,
			width: 80
		}, {
			id: 'weeklyOpportunityDelta',
			display: 'Weekly Opportunity Change',
			class: 'alignRight',
			renderer: tableRenderService.ppvRenderer,
			width: 80
		}, {
			id: 'next30Days',
			display: 'On Order Next 30 Days',
			class: 'alignRight',
			renderer: tableRenderService.onOrderNextXDays,
			days: 30,
			width: 80
		}, {
			id: 'next60Days',
			display: 'On Order Next 60 Days',
			class: 'alignRight',
			renderer: tableRenderService.onOrderNextXDays,
			show: false,
			days: 60,
			width: 80
		}, {
			id: 'next90Days',
			display: 'On Order Next 90 Days',
			class: 'alignRight',
			renderer: tableRenderService.onOrderNextXDays,
			show: false,
			days: 90,
			width: 80
		}, {
			id: 'averageMonthlyDemandFromPastRqmts',
			display: 'Past Demand (Monthly)',
			class: 'alignRight',
			width: 100,
			renderer: tableRenderService.avgPeriodicDemand,
			inputPeriod: 'daily',
			period: 'monthly'
		}, {
			id: 'averageDailyDemandFromPastRqmts',
			display: 'Past Demand (Daily)',
			class: 'alignRight',
			width: 100,
			renderer: tableRenderService.avgPeriodicDemand,
			inputPeriod: 'daily',
			period: 'daily'
		}, {
			id: 'averageDailyDemandFromFutureRqmts',
			display: 'Future Demand (Daily)',
			class: 'alignRight',
			width: 100,
			renderer: tableRenderService.avgPeriodicDemand,
			inputPeriod: 'daily',
			period: 'daily'
		}, {
			id: 'averageMonthlyDemandFromFutureRqmts',
			display: 'Future Demand (Monthly)',
			class: 'alignRight',
			width: 100,
			renderer: tableRenderService.avgPeriodicDemand,
			inputPeriod: 'daily',
			period: 'monthly'
		}, {
			id: 'productHierarchy',
			display: 'Product Hierarchy',
			width: 120
		}, {
			id: 'costPerItemFloat',
			display: 'Unit Price',
			width: 100,
			renderer: tableRenderService.currency,
			keepAllDecimals: true
		}, {
			id: 'purchasingUOM',
			display: 'UOM',
			show: false,
			width: 80
		}, {
			id: 'totalOnHandConsignmentQuantity',
			display: 'Consignment Qty',
			renderer: tableRenderService.integer,
			width: 100
		}, {
			id: 'totalOnHandUnrestrictedConsignmentQuantity',
			display: 'Unrestricted Consignment Qty',
			renderer: tableRenderService.integer,
			width: 80
		}, {
			id: 'overMaxValue',
			display: 'Value Over Max',
			renderer: tableRenderService.currency,
			show: false,
			width: 80
		}, {
			id: 'totalOnHandUnrestrictedQuantity',
			display: 'On Hand (Unrestricted)',
			renderer: tableRenderService.onHand,
			width: 80
		}, {
			id: 'safetyStockFloat',
			display: 'Safety Stock',
			width: 100,
			sort: true,
			renderer: tableRenderService.integer
		}, {
			id: 'maxLevelFloat',
			display: 'Max Level',
			width: 100,
			renderer: tableRenderService.integer
		}, {
			id: 'calculatedMaxLevel',
			display: 'Recommended Max Level',
			renderer: tableRenderService.integer,
			show: false,
			width: 80
		}, {
			id: 'currentReOrderPoint',
			display: 'Reorder Point',
			width: 100,
			renderer: tableRenderService.integer
		}, {
			id: 'currentReOrderQty',
			display: 'Reorder Qty',
			width: 100,
			renderer: tableRenderService.integer
		}, {
			id: 'totalOnHandQuantityFloat',
			display: 'Total On Hand Qty',
			renderer: tableRenderService.hyperlinkShortage,
			width: 100
		}, {
			id: 'currentOnHandCostFloat',
			display: 'Total On Hand Value',
			renderer: tableRenderService.currency,
			show: false,
			width: 80
		}, {
			id: 'daysOfInventoryBackwards',
			display: 'Days of Inventory Backward',
			renderer: tableRenderService.integer,
			show: false,
			width: 80
		}, {
			id: 'daysOfInventoryForwards',
			display: 'Days of Inventory Forward',
			renderer: tableRenderService.integer,
			show: false,
			width: 80
		}, {
			id: 'totalOnHandValue',
			display: 'Total On Hand Value',
			renderer: tableRenderService.currency,
			width: 100
		}, {
			id: 'totalOnOrderQuantityFloat',
			display: 'On Order Qty',
			renderer: tableRenderService.hyperlinkShortage,
			width: 100
		}, {
			id: 'totalOnOrderValue',
			display: 'Total On Order Value',
			width: 80,
			show: false,
			renderer: tableRenderService.onOrderValue
		}, {
			id: 'ctbShortageImpactedValue',
			display: 'CTB Shortage Impacted Value',
			renderer: tableRenderService.currency,
			show: false,
			width: 110
		}, {
			id: 'ctbImpactedOrdersSingleShortageCount',
			display: 'CTB Impacted Orders (as single shortage)',
			renderer: tableRenderService.integer,
			show: false,
			width: 110
		}, {
			id: 'analysisTargetInventoryQty',
			display: 'Recommended Target Inventory Quantity',
			width: 120,
			renderer: tableRenderService.integer
		}, {
			id: 'estimatedSavings',
			display: 'Estimated Savings',
			renderer: tableRenderService.currency,
			width: 80
		}, {
			id: 'analysisReplenishmentType',
			display: 'Recommended Policy',
			width: 120
		}, {
			id: 'analysisSafetyStockLevelFloat',
			display: 'Recommended Safety Stock',
			width: 120,
			sort: true,
			renderer: tableRenderService.integer
		}, {
			id: 'currentReorderQty',
			display: 'Reorder Qty',
			renderer: tableRenderService.integer,
			show: false,
			width: 80
		}, {
			id: 'recommendedReorderPointInt',
			display: 'Recommended Reorder Point',
			width: 120,
			renderer: tableRenderService.integer
		}, {
			id: 'recommendedReorderQtyFloat',
			display: 'Recommended Reorder Qty',
			width: 120,
			renderer: tableRenderService.integer
		}, {
			id: 'minimumOrderQuantityFloat',
			display: 'MOQ',
			show: false,
			width: 80,
			renderer: tableRenderService.decimal
		}, {
			id: 'futureDemandThisWeek',
			display: 'Future Demand This Week',
			show: false,
			width: 110,
			renderer: tableRenderService.currency
		}, {
			id: 'futureDemandWeeklyChangePercent',
			display: 'Future Demand Weekly Change',
			show: false,
			width: 135,
			renderer: tableRenderService.percent
		}, {
			id: 'futureDemandWeeklyChangeValue',
			display: 'Future Demand Weekly Change Value',
			show: false,
			width: 135,
			renderer: tableRenderService.currency
		}, {
			id: 'totalShortageOccurrences',
			display: 'Total Shortage Occurrences (Last 12 Months)',
			show: false,
			width: 135,
			renderer: tableRenderService.integer
		}, {
			id: 'numDaysAsAShortage',
			display: 'Number of Days as a Shortage (Last 12 Months)',
			show: false,
			width: 135,
			renderer: tableRenderService.integer
		}, {
			id: 'averageDaysInShortage',
			display: 'Average Days in Shortage (Last 12 Months)',
			show: false,
			width: 135,
			renderer: tableRenderService.integer
		}, {
			id: 'maxDaysInShortage',
			display: 'Max Days in Shortage (Last 12 Months)',
			show: false,
			width: 135,
			renderer: tableRenderService.integer
		}, {
			id: 'demandCoefficientOfVariation',
			display: 'Coefficient of variation',
			show: false,
			width: 80,
			renderer: tableRenderService.decimal
		}, {
			id: 'aggregateRiskScore',
			display: 'Aggregate Risk Score',
			show: false,
			width: 80,
			renderer: tableRenderService.aggregateRiskScoreRenderer,
			sort: true
		}, {
			id: 'aggregateRiskScoreLabel',
			display: 'Risk Level',
			show: false,
			width: 160,
			sort: true
		}, {
			id: 'analysisABCMOQFloat',
			display: 'Recommended MOQ',
			show: false,
			width: 80,
			renderer: tableRenderService.decimal
		}, {
			id: 'recommendedLotSize',
			display: 'Recommended Lot Size',
			show: false,
			width: 80,
			renderer: tableRenderService.decimal
		}, {
			id: 'analysisXYZClass',
			display: 'Calculated XYZ Rank',
			show: false,
			width: 80
		}, {
			id: 'analysisTargetInventoryQty',
			display: 'Target Qty',
			renderer: tableRenderService.integer,
			show: false,
			width: 80
		}];
	}
	function hideFromSuppliers() {
		return globalConfig.user.role !== 'Supplier';
	}
	function hideFromSpiritSuppliers() {
		return globalConfig.user.role !== 'Supplier' || globalConfig.customer.id !== 90;
	}
})();
